import { render, staticRenderFns } from "./branchCreate.vue?vue&type=template&id=a3ba67e8&"
import script from "./branchCreate.vue?vue&type=script&lang=js&"
export * from "./branchCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports